<child-header title="Alias Login" (closeEvent)="cancelAliasLogin()"></child-header>
<div class="mat-dialog-body">
  <!-- <h1 mat-dialog-title class="pop-up-title padding-l-x16">ALIAS LOGIN</h1> -->
  <loading-icon [currentLoadingStatus]="!loginStatus"></loading-icon>
  <div class="mat-dialog-content" *ngIf="loginStatus">
    <div class="modal-body" [formGroup]="aliasFromGroup">
      <!-- <mat-form-field>
                    <input matInput id="txtAccountSearch" formControlName="txtAccountSearch" [matAutocomplete]="auto"
                        (blur)='txtAccountSearch_Onblur($event)' placeholder="Search account by name or id" required>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)='accountSelected($event.option.value)'>
                    <mat-option *ngIf="isLoading" class="is-loading">
                        <mat-spinner diameter="25" color='warn'></mat-spinner>
                    </mat-option>
                    <ng-container *ngIf="!isLoading">
                        <mat-option *ngFor="let account of accountList" [value]="account">
                            <small>{{ account.accountName }}</small>
                            <small> | {{account.accountId}}</small>
                        </mat-option>
                    </ng-container>
                </mat-autocomplete> -->
      <ng-select class="customDropdwon" typeToSearchText="Please enter 3 or more characters"
        formControlName="txtAccountSearch" [items]="accountList" bindLabel="accountName" [typeahead]="peopleInput$"
        bindValue="accountId" placeholder="Search account by name or id *" [loading]="isLoading"
        (change)="accountSelected()">
        <ng-template ng-option-tmp let-item="item">
          <small>{{ item.accountName }}</small>
          <small> | {{item.accountId}}</small>
        </ng-template>
      </ng-select>
      <mat-form-field>
        <input class="accountname" matInput required formControlName="txtAccountName" readonly placeholder="Account">
      </mat-form-field>
      <!-- <input hidden matInput formControlName="txtLogin">
        <mat-form-field>
          <mat-label>User</mat-label>
          <mat-select formControlName="txtLoginId" placeholder="Select Login"
            (selectionChange)="loginSelected($event.value)" [(ngModel)]="selectedUser">
            <mat-option *ngFor="let user of contactList" [value]="user">
              <small> {{user.out_login_id}} </small>
              <small>
                {{user.out_purch_officer == 'Y' ? ' $' : '' }}</small>
              <small>
                {{user.out_administrator == 'Y' ? ' @' : '' }}</small>
            </mat-option>
          </mat-select>
        </mat-form-field> -->
      <ng-select class="customDropdwon" formControlName="txtLoginId" [items]="contactList" bindLabel="out_login_id"
        bindValue="out_login_id" [(ngModel)]="selectedUser" placeholder="User *" (change)="contactSelected()">
        <ng-template ng-label-tmp let-item="item">
          {{item.out_login_id}}{{item.out_purch_officer == 'Y' ? ' $' : '' }}{{item.out_administrator == 'Y' ? ' @' : '' }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <small> {{item.out_login_id}} </small>
          <small>
            {{item.out_purch_officer == 'Y' ? ' $' : '' }}</small>
          <small>
            {{item.out_administrator == 'Y' ? ' @' : '' }}</small>
        </ng-template>
      </ng-select>
    </div>
    <div mat-dialog-actions class="btn-center">
      <button type="submit" class="button button-red button-mid" (click)="aliasLogin()">Login</button>
      <button class="button button-red button-mid margin-l-x30" id="cancel-button" (click)="cancelAliasLogin()">Cancel
      </button>
    </div>
  </div>
</div>